// 网关列表 包含该网关下的服务列表。使用时根据网关+服务来使用
const getWayList = [
    {
      'getWayKey': 'bossapi', // key值，使用时key用这个
      'getWayValue': 'com-easy', // 具体的值
      'services': {
        'system': ''
      }
    }
  ];
  let basePath = null;
  const initBaseUrl = (basePaths) => {
    const origin = window.location.origin;
    const basePathsObj = {};
    basePaths.map((basePath) => {
      basePathsObj[basePath.getWayKey] = {};
      for (const serviceName in basePath.services) {
        basePathsObj[basePath.getWayKey][serviceName] = origin + '/' + basePath.getWayValue + '/' + basePath.services[serviceName];
      }
    });
    basePath = basePathsObj;
    return basePath;
  };
// 构造函数，参数可以传getWay数组进来，会追加到变量getWayList里
const basePathInit = (list) => {
    if (list && Array.isArray(list) && list.length > 0) {
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        if (element) {
          getWayList.push(element);
        }
      }
    }
    return initBaseUrl(getWayList);
  };
  
  export {
    basePathInit
  };
  